import { __awaiter, __extends, __generator } from "tslib";
// Basics
import * as React from 'react';
import { container } from 'tsyringe';
import ContentViewRoute from './ContentViewRoute';
import { Redirect, Switch, Router } from "react-router";
import Managers from '../../Architecture/Managers/Constants/Managers';
import AuthManager from '../../Architecture/Managers/Classes/AuthManager';
import HttpManager from '../../Architecture/Managers/Classes/HttpManager';
import PopUpManager from '../../Architecture/Managers/Classes/PopUpManager';
import ModuleManager from '../../Architecture/Managers/Classes/ModuleManager';
import StorageManager from '../../Architecture/Managers/Classes/StorageManager';
import LanguageManager from '../../Architecture/Managers/Classes/LanguageManager';
import NavigationManager from '../../Architecture/Managers/Classes/NavigationManager';
import TranslationManager from '../../Architecture/Managers/Classes/TranslationManager';
import { View, TouchableWithoutFeedback, Dimensions, BackHandler, Platform, Linking } from 'react-native';
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        var width = Platform.OS == "web" ? window.innerWidth : 0;
        var height = Platform.OS == "web" ? window.innerHeight : 0;
        _this.state = { popUpVisible: false, toastVisible: false, toast: undefined, popUp: undefined, width: width, height: height };
        //Application instance for testing
        Application.current = _this;
        // HOT RELOAD FIX
        _this.reset = _this.reset.bind(_this);
        _this.render = _this.render.bind(_this);
        _this.resolve = _this.resolve.bind(_this);
        _this.register = _this.register.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.renderRouter = _this.renderRouter.bind(_this);
        _this.initialisation = _this.initialisation.bind(_this);
        _this.renderApplication = _this.renderApplication.bind(_this);
        _this.initialisation();
        _this.resolve(Managers.LANGUAGE_MANAGER).checkLanguage();
        return _this;
    }
    Application.prototype.componentDidMount = function () {
        if (Platform.OS !== "web") {
            Linking.addEventListener('url', this.resolve(Managers.NAVIGATION_MANAGER).handleOpenURL);
            BackHandler.addEventListener("hardwareBackPress", this.resolve(Managers.NAVIGATION_MANAGER).navigateToPrevious);
        }
        else if (Platform.OS === "web") {
            window.addEventListener('resize', this.handleResize);
        }
    };
    Application.prototype.componentWillUnmount = function () {
        if (Platform.OS !== "web") {
            Linking.removeEventListener('url', this.resolve(Managers.NAVIGATION_MANAGER).handleOpenURL);
            BackHandler.removeEventListener("hardwareBackPress", this.resolve(Managers.NAVIGATION_MANAGER).navigateToPrevious);
        }
        else if (Platform.OS === "web") {
            window.removeEventListener('resize', this.handleResize);
        }
    };
    Application.prototype.handleResize = function () {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };
    /* INIT */
    Application.prototype.initialisation = function () {
        var _this = this;
        this.register(Managers.POPUP_MANAGER, new PopUpManager());
        this.register(Managers.NAVIGATION_MANAGER, new NavigationManager());
        var storageManager = new StorageManager();
        this.register(Managers.STORAGE_MANAGER, storageManager);
        var authManager = new AuthManager("", "", "", storageManager);
        this.register(Managers.AUTH_MANAGER, authManager);
        this.register(Managers.HTTP_MANAGER, new HttpManager('', function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); }, authManager));
        this.register(Managers.TRANSLATION_MANAGER, new TranslationManager(''));
        this.register(Managers.LANGUAGE_MANAGER, new LanguageManager('fr-BE', ['fr-BE']));
        this.register(Managers.MODULE_MANAGER, new ModuleManager());
    };
    /* MANAGER CONTAINER */
    Application.prototype.resolve = function (typeName) {
        return container.resolve(typeName);
    };
    Application.prototype.register = function (typeName, instance) {
        container.registerInstance(typeName, instance);
    };
    Application.prototype.reset = function () {
        container.reset();
    };
    Application.prototype.registerModule = function (moduleId, moduleName) {
        this.resolve(Managers.MODULE_MANAGER).registerModule(moduleId, moduleName);
    };
    /* RENDERING */
    Application.prototype.render = function () {
        var _this = this;
        { /* position: this.state.popUpVisible ? 'absolute' : 'relative',*/ }
        return this.renderRouter(React.createElement(View, { style: { height: '100%' } },
            this.state.popUpVisible && Platform.OS == "web" ? (React.createElement(View, { style: { overflowY: this.state.popUpVisible ? 'hidden' : 'auto', width: this.state.width, height: this.state.height } },
                React.createElement(Switch, null,
                    React.createElement(ContentViewRoute, { path: "/:language/", render: function () { return _this.renderApplication(); } }),
                    React.createElement(ContentViewRoute, { exact: true, path: "/", render: function () { return React.createElement(Redirect, { to: "/" + _this.resolve(Managers.LANGUAGE_MANAGER).language + "/" }); } })))) :
                (React.createElement(View, { style: { overflowY: this.state.popUpVisible ? 'hidden' : 'auto', width: '100%', height: '100%' } },
                    React.createElement(Switch, null,
                        React.createElement(ContentViewRoute, { path: "/:language/", render: function () { return _this.renderApplication(); } }),
                        React.createElement(ContentViewRoute, { exact: true, path: "/", render: function () { return React.createElement(Redirect, { to: "/" + _this.resolve(Managers.LANGUAGE_MANAGER).language + "/" }); } })))),
            this.state.toastVisible && Platform.OS == "web" ? (React.createElement(View, { style: { zIndex: 300, position: 'absolute', bottom: 100, right: 0 } }, this.state.toast.map(function (value) {
                return React.createElement(View, { style: { paddingVertical: 5 } }, value);
            }))) : this.state.toastVisible && (React.createElement(View, { style: { zIndex: 300, elevation: 300, position: 'absolute' } }, this.state.toast)),
            this.state.popUpVisible && Platform.OS == "web" ? (React.createElement(View, { style: { opacity: this.state.popUpVisible ? 1 : 0, position: 'absolute', zIndex: this.state.popUpVisible ? 200 : -1, height: Dimensions.get('window').height, width: '100%', justifyContent: 'center' } },
                React.createElement(TouchableWithoutFeedback, { onPress: function () { return _this.resolve(Managers.POPUP_MANAGER).closePopUp(); } },
                    React.createElement(View, { style: { opacity: this.state.popUpVisible ? 0.7 : 0, position: 'absolute', backgroundColor: 'black', height: '100%', width: '100%', zIndex: this.state.popUpVisible ? 200 : -1 } })),
                React.createElement(View, { style: { zIndex: this.state.popUpVisible ? 200 : -1, minHeight: 150, overflowY: 'auto', overflowX: 'hidden', maxHeight: "90%", maxWidth: '95%', backgroundColor: 'white', borderRadius: 8, boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)', display: 'flex', alignSelf: 'center' } }, this.state.popUp))) : this.state.popUpVisible && (React.createElement(View, { style: { zIndex: 200, elevation: 200, position: 'absolute' } }, this.state.popUp))));
    };
    Application.prototype.renderApplication = function () {
        return (React.createElement(View, null));
    };
    Application.prototype.renderRouter = function (children) {
        return (React.createElement(Router, { history: this.resolve(Managers.NAVIGATION_MANAGER).history }, children));
    };
    return Application;
}(React.Component));
export default Application;
